import React from 'react';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import * as Actions from '../../../../Reducers/actions'
import { useNavigate } from 'react-router-dom';
import { Tooltip, IconButton } from '@mui/material';

import { Info } from 'lucide-react';

import { dataService } from "../../../../Services/data/data.service";


function ProjectButton(props) {
    const navigate = useNavigate();

    const SaveAndRedirect = () => {

        navigate(`/modifyproject/${props.data.qrCode}`);

    }

    return (
        <Tooltip title="Project information" placement="top" disableInteractive arrow>
            <IconButton style={{ borderRadius: 0 }} onClick={SaveAndRedirect}>
                <Info />
            </IconButton>
        </Tooltip>
    )
}

const mapStateToProps = state => ({
    projects: state.projects,
})

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(Actions, dispatch)
})

export default compose(connect(
    mapStateToProps,
    mapDispatchToProps
))(ProjectButton);